/**
 * Session-only match-time override while scrubbing shadowing cues.
 * Paint uses this instead of the live video clock so the ticker can follow
 * the pointer without seeking until release.
 */

let previewMs: number | null = null;

export function getTimingPreviewMs(): number | null {
  return previewMs;
}

export function setTimingPreviewMs(ms: number): void {
  previewMs = Number.isFinite(ms) ? ms : null;
}

export function clearTimingPreviewMs(): void {
  previewMs = null;
}
